import { KeepAliveStore, KEEP_ALIVE_FAILED, KEEP_ALIVE_SUCCESS } from './types';

export const keepAlive = (
  state: KeepAliveStore = {},
  action: {
    type: string;
    payload?: string;
  }
): KeepAliveStore => {
  switch (action.type) {
    case KEEP_ALIVE_SUCCESS: {
      const { err: _err, ...restState } = state;
      return {
        ...restState,
        sessionExpiration: action.payload
      };
    }
    case KEEP_ALIVE_FAILED:
      return { err: action.payload };
    default:
      return state;
  }
};
